import { extractSingleHttpUrl } from '../lib/url-input.js';
import { TryModes, type TryMode } from './try-mode-tabs.js';

export function detectTryModeFromTextInput(value: string): TryMode | null {
  const trimmed = value.trim();
  if (!trimmed) {
    return null;
  }

  const url = extractSingleHttpUrl(trimmed);
  if (!url) {
    return TryModes.TEXT;
  }

  const host = resolveHostname(url);
  if (host === null) {
    return TryModes.URL;
  }
  if (host === 'youtu.be' || host === 'youtube.com' || host.endsWith('.youtube.com')) {
    return TryModes.YOUTUBE;
  }
  if (host === 'docs.google.com') {
    return TryModes.GOOGLEDOC;
  }
  return TryModes.URL;
}

function resolveHostname(url: string): string | null {
  try {
    return new URL(url).hostname.toLowerCase();
  } catch {
    return null;
  }
}
